/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { GET_CAMPGROUND_RATES, GET_CAMPGROUND_RATES_ERROR } from '../constants';

const INITIALSTATE = {
    results: [],
};

export default function campground(state = INITIALSTATE, action) {
    const st = { ...state };

    switch (action.type) {
        case GET_CAMPGROUND_RATES:
            return { results: action.payload, isValid: true };
        case GET_CAMPGROUND_RATES_ERROR:
            return { error: action.error, results: {}, isValid: false };
        default:
            return st;
    }
}
